import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBlenderPhone,
  faHome,
  faBell,
  faEnvelope,
  faExpand,
  faGear,
  faFile,
  faArrowRight,
  faGears,
  faNetworkWired,
  faCubes,
  faCartShopping,
  faFileInvoice,
  faSackDollar,
  faNoteSticky,
  faListCheck,
  faCreditCard,
  faShoppingCart,
  faWarehouse,
  faUserPlus,
  faIndustry,
  faUserTie,
  faUserGroup,
  faReplyAll,
  faBox,
  faMoneyBillWave,
  faClipboardList,
  faFileInvoiceDollar,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
// import Reminders from './reminders.svg';
import CRMLOGO from "../../Assets/pocketbiz.png";

import { Popover } from "antd";
import {
  SettingOutlined,
  AppstoreOutlined,
  TagsOutlined,
  PercentageOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import { API_BASE_CRM_URL } from "./Config";

const Base = ({ children }) => {
  const [userDetails, SetUserDetails] = useState([]);

  useEffect(() => {
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails"),
    );
    SetUserDetails(userDetailsSession);
  }, []);

  const navigate = useNavigate();

  const location = useLocation();

  const [leadsIsOpen, setLeadsIsOpen] = useState(false);
  const [customersIsOpen, setCustomersIsOpen] = useState(false);
  const [productionIsOpen, setProductionIsOpen] = useState(false);
  const [salesIsOpen, setSalesIsOpen] = useState(false);
  const [inventoryOpen, setInventoryOpen] = useState(false);
  const [masterIsOpen, setMasterIsOpen] = useState(false);
  const [reportIsOpen, setReportIsOpen] = useState(false);

  const [isFullscreen, setIsFullscreen] = useState(false);
  const [projectsIsOpen, setProjectsIsOpen] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);

  useEffect(() => {
    const path = location.pathname;

    if (path.includes("individualleads") || path.includes("corporateleads")) {
      setLeadsIsOpen(true);
    } else {
      setLeadsIsOpen(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    setCustomersIsOpen(
      location.pathname.includes("customers") ||
        location.pathname.includes("projects") ||
        location.pathname.includes("purchase-order"),
    );
  }, [location.pathname]);

  useEffect(() => {
    setProductionIsOpen(
      location.pathname.includes("dispatchschedule") ||
        location.pathname.includes("dailycount") ||
        location.pathname.includes("dailyproduction"),
    );
  }, [location.pathname]);

  useEffect(() => {
    setSalesIsOpen(
      location.pathname.includes("proposal") ||
        location.pathname.includes("payments") ||
        location.pathname.includes("delivery-challan"),
    );
  }, [location.pathname]);

  useEffect(() => {
    setMasterIsOpen(
      location.pathname.includes("products") ||
        location.pathname.includes("designmix") ||
        location.pathname.includes("transporter") ||
        location.pathname.includes("drivers") ||
        location.pathname.includes("vehicle") ||
        location.pathname.includes("update-End-Reading") ||
        location.pathname.includes("slabrate"),
    );
  }, [location.pathname]);

  useEffect(() => {
    setReportIsOpen(
      location.pathname.includes("leads-report") ||
        location.pathname.includes("customers-report") ||
        location.pathname.includes("reminders-report"),
    );
  }, [location.pathname]);

  const LeadsToggleDropdown = () => {
    setLeadsIsOpen(!leadsIsOpen);
    setCustomersIsOpen(false);
    setProductionIsOpen(false);
    setSalesIsOpen(false);
    setInventoryOpen(false);
    setMasterIsOpen(false);
    setReportIsOpen(false);
  };

  const CustomersToggleDropdown = () => {
    setLeadsIsOpen(false);
    setCustomersIsOpen(!customersIsOpen);
    setProductionIsOpen(false);
    setSalesIsOpen(false);
    setInventoryOpen(false);
    setMasterIsOpen(false);
    setReportIsOpen(false);
  };

  const ProductionToggleDropdown = () => {
    setLeadsIsOpen(false);
    setCustomersIsOpen(false);
    setProductionIsOpen(!productionIsOpen);
    setSalesIsOpen(false);
    setInventoryOpen(false);
    setMasterIsOpen(false);
    setReportIsOpen(false);
  };

  const SalesToggleDropdown = () => {
    setLeadsIsOpen(false);
    setCustomersIsOpen(false);
    setProductionIsOpen(false);
    setSalesIsOpen(!salesIsOpen);
    setInventoryOpen(false);
    setMasterIsOpen(false);
    setReportIsOpen(false);
  };

  const InventoryToggleDropdown = () => {
    setLeadsIsOpen(false);
    setCustomersIsOpen(false);
    setProductionIsOpen(false);
    setSalesIsOpen(false);
    setInventoryOpen(!inventoryOpen);
    setMasterIsOpen(false);
    setReportIsOpen(false);
  };

  const MasterToggleDropdown = () => {
    setLeadsIsOpen(false);
    setCustomersIsOpen(false);
    setProductionIsOpen(false);
    setSalesIsOpen(false);
    setInventoryOpen(false);
    setMasterIsOpen(!masterIsOpen);
    setReportIsOpen(false);
  };

  const ReportsToggleDropdown = () => {
    setLeadsIsOpen(false);
    setCustomersIsOpen(false);
    setProductionIsOpen(false);
    setSalesIsOpen(false);
    setInventoryOpen(false);
    setMasterIsOpen(false);
    setReportIsOpen(!reportIsOpen);
  };

  const ProjectsToggleDropdown = () => {
    setProjectsIsOpen(!projectsIsOpen);
    setReportIsOpen(false);
    setMasterIsOpen(false);
    setSalesIsOpen(false);
    setInventoryOpen(false);
  };

  const getOrgSettings = async () => {
    try {
      const response = await fetch(
        `${API_BASE_CRM_URL}/dashboard/GetOrgSettings`,
      );

      const data = await response.json();

      if (data.Status) {
        sessionStorage.setItem("OrgSettings", JSON.stringify(data.ResultData));
      }
    } catch (err) {
      console.error("Error loading organization settings:", err);
    }
  };

  useEffect(() => {
    getOrgSettings();
  }, []);
  // useEffect(() => {
  //   const reportPaths = [
  //     "/leads-report",
  //     "/customers-report",
  //     "/reminders-report",
  //     "/followups-report",
  //   ];

  //   if (reportPaths.includes(location.pathname)) {
  //     setReportIsOpen(true);
  //   } else {
  //     setReportIsOpen(false);
  //   }
  // }, [location.pathname]);

  const handleLogout = () => {
    sessionStorage.removeItem("userDetails");
    navigate("/");
  };

  // const useDropdownState = (paths, setState) => {
  //   const location = useLocation();

  //   useEffect(() => {
  //     if (paths.includes(location.pathname)) {
  //       setState(true);
  //     }
  //   }, [location.pathname, paths, setState]);
  // };

  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  useEffect(() => {
    document.body.style.overflow = "";
    document.body.classList.remove("offcanvas-backdrop");
  }, [location.pathname]);

  const closeOffcanvas = () => {
    const offcanvas = document.getElementById("offcanvasExample");

    if (offcanvas) {
      const bsOffcanvas = window.bootstrap?.Offcanvas.getInstance(offcanvas);

      if (bsOffcanvas) {
        bsOffcanvas.hide();
      }
    }

    document.body.style.overflow = "";
    document.body.classList.remove("offcanvas-open");
  };

  const settingsContent = (
    <div
      className="d-flex align-items-center border rounded p-3"
      style={{ cursor: "pointer" }}
      onClick={() => {
        navigate("/products");
        setOpenSettings(false); // Optional: close the popover
      }}
    >
      <FontAwesomeIcon
        icon={faBox}
        className="me-3"
        style={{ color: "#1B2850", fontSize: "18px" }}
      />
      <span className="fw-semibold">Products</span>
    </div>
  );

  return (
    <>
      <style>
        {`
      .sidebar-menu {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
      
      .menu-link {
        display: flex;
        align-items: center;
        min-height: 46px;
        padding: 10px 16px;
        text-decoration: none;
        border-radius: 8px;
      }
      
      .menu-link svg {
        width: 22px;
        min-width: 22px;
      }
      
      .menu-link span {
        margin-left: 12px;
      }
      
      .submenu {
        display: flex;
        flex-direction: column;
        margin-left: 20px;
      }
      
      .submenu-link {
        display: flex;
        align-items: center;
        padding: 8px 16px;
        text-decoration: none;
      }
      
      .submenu-link svg {
        width: 16px;
        min-width: 16px;
      }
      
      .submenu-link span {
        margin-left: 10px;
      }

      
      


















      
      `}
      </style>

      <div className="main-wrapper">
        {/* Header */}
        <div className="header">
          <div className="header-left active">
            <a className="logo logo-normal">
              <Link to="/dashboard">
                <img src={CRMLOGO} alt="crmlogo" />
              </Link>
            </a>
            <a className="logo logo-white">
              <Link to="/dashboard">
                <img src={CRMLOGO} alt="crmlogo" />
              </Link>
            </a>
            <a className="logo-small">
              <Link to="/dashboard">
                <img src={CRMLOGO} alt="crmlogo" />
              </Link>
            </a>
          </div>
          <a
            className="mobile_btn"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasExample"
            aria-controls="offcanvasExample"
          >
            <span className="bar-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </a>

          <ul
            className="nav user-menu"
            style={{ backgroundColor: "rgb(10, 31, 62)" }}
          >
            <li className="nav-item nav-searchinputs">
              <div className="top-nav-search">
                <a
                  // href="javascript:void(0);"
                  className="responsive-search"
                >
                  <i className="fa fa-search"></i>
                </a>
                <form action="#" className="dropdown">
                  <div className="searchinputs dropdown-toggle">
                    <input type="text" placeholder="Search" />
                    <div className="search-addon">
                      <span>
                        <i data-feather="x-circle" className="feather-14"></i>
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </li>

            <li className="nav-item">
              <div className="position-relative" style={{ cursor: "pointer" }}>
                <Link to="/notifications">
                  <i className="fa-regular fa-bell fs-4 text-white"></i>

                  <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                    style={{
                      fontSize: "10px",
                      minWidth: "18px",
                      height: "18px",
                      lineHeight: "18px",
                      padding: "0 5px",
                    }}
                  >
                    5
                  </span>
                </Link>
              </div>
            </li>
            <li className="nav-item nav-item-box">
              <Link
                to="#"
                id="btnFullscreen"
                onClick={() => toggleFullscreen()}
                className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
              >
                <FeatherIcon
                  icon={`${isFullscreen ? "minimize" : "maximize"}`}
                />
              </Link>
            </li>

            <li className="nav-item dropdown has-arrow main-drop">
              <a
                className="dropdown-toggle nav-link userset"
                data-bs-toggle="dropdown"
              >
                <span className="user-info">
                  <span className="user-letter">
                    <img
                      src="assets/img/profiles/avator1.jpg"
                      alt=""
                      className="img-fluid"
                    />
                  </span>
                  <span className="user-detail">
                    <span className="user-name text-white">
                      {userDetails?.firstname + " " + userDetails?.lastname}
                    </span>
                    <span className="user-role text-white">Super Admin</span>
                  </span>
                </span>
              </a>
              <div className="dropdown-menu menu-drop-user">
                <div className="profilename">
                  <div className="profileset">
                    <span className="user-img">
                      <img src="assets/img/profiles/avator1.jpg" alt="" />
                      <span className="status online"></span>
                    </span>
                    <div className="profilesets">
                      <h6>
                        {userDetails?.firstname + " " + userDetails?.lastname}
                      </h6>
                      <h5>Super Admin</h5>
                    </div>
                  </div>
                  <hr className="m-0" />
                  <hr className="m-0" />
                  <a
                    className="dropdown-item logout pb-0"
                    onClick={handleLogout}
                  >
                    <img
                      src="assets/img/icons/log-out.svg"
                      className="me-2"
                      alt="img"
                    />
                    Logout
                  </a>
                </div>
              </div>
            </li>

            <li className="nav-item dropdown has-arrow main-drop">
              {/* User Profile */}
            </li>
          </ul>

          <div className="d-flex align-items-center mobile-user-menu mx-3">
            <div
              className="position-relative d-inline-block me-3"
              style={{ cursor: "pointer" }}
            >
              <Link to="/notifications">
                {/* Bell Icon */}
                <i className="fa-regular fa-bell fa-shake text-primary fs-4"></i>

                {/* Notification Badge */}
                <span
                  className="position-absolute top-0 mt-3  start-100 translate-middle badge rounded-pill bg-danger"
                  style={{
                    fontSize: "8px",
                    minWidth: "18px",
                    height: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0 5px",
                    lineHeight: 1,
                  }}
                >
                  2
                </span>
              </Link>
            </div>

            <div className="dropdown">
              <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                <i className="fa fa-ellipsis-v"></i>
              </a>

              <div className="dropdown-menu dropdown-menu-end">
                <a className="dropdown-item" onClick={handleLogout}>
                  Logout
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="sidebar d-none d-md-block d-lg-block" id="sidebar">
          <div className="sidebar-inner slimscroll" style={{ height: "100vh" }}>
            <div
              className="flex-grow-1 slimscroll"
              style={{ overflowY: "auto" }}
            >
              <div id="sidebar-menu" className="sidebar-menu">
                <ul>
                  <li className="submenu-open">
                    <ul>
                      <li>
                        <Link
                          to="/dashboard"
                          className={
                            location.pathname === "/dashboard"
                              ? "text-primary"
                              : ""
                          }
                        >
                          <FontAwesomeIcon icon={faHome} className="me-2 " />
                          Dashboard
                        </Link>
                      </li>
                      {/* leads */}

                      <li className="mb-2 fw-semibold">
                        <Link
                          to="/leads"
                          className={
                            location.pathname === "/leads" ? "text-primary" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faUserPlus} className="me-2" />
                          Leads
                        </Link>
                      </li>

                      <li className="mb-2 fw-semibold">
                        <Link
                          to="/proposal"
                          className={
                            location.pathname === "/proposal"
                              ? "text-primary"
                              : ""
                          }
                        >
                          <FontAwesomeIcon
                            icon={faClipboardList}
                            className="me-2"
                          />
                          Proposal
                        </Link>
                      </li>
                      <li className="mb-2 fw-semibold">
                        <Link
                          to="/customers"
                          className={
                            location.pathname === "/customers"
                              ? "text-primary"
                              : ""
                          }
                        >
                          <FontAwesomeIcon icon={faUserTie} className="me-2" />
                          Customers
                        </Link>
                      </li>

                      {/* payments */}
                      <li>
                        <div className="dropdown">
                          <p
                            className="d-flex"
                            style={{ cursor: "pointer" }}
                            onClick={CustomersToggleDropdown}
                          >
                            <a>
                              <span>
                                <FontAwesomeIcon
                                  icon={faCreditCard}
                                  className="me-2 "
                                />
                                Payments
                                <i
                                  className={`fa-solid fa-chevron-${
                                    customersIsOpen ? "up" : "down"
                                  }  fs-6`}
                                  style={{ marginLeft: "5.2rem" }}
                                ></i>
                              </span>
                            </a>
                          </p>
                          {customersIsOpen && (
                            <div
                              className="dropdown-content"
                              style={{ marginTop: "-20px" }}
                            >
                              <ul className="ms-3">
                                <li>
                                  <Link
                                    to="/credits"
                                    className={
                                      location.pathname === "/credits"
                                        ? "text-primary"
                                        : ""
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faArrowRight}
                                      className="me-2"
                                    />
                                    Collections
                                  </Link>
                                </li>
                                {/* <li>
                              <Link
                                to="/projects"
                                className={
                                  location.pathname === "/projects"
                                    ? "text-primary"
                                    : ""
                                }
                              >
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  className="me-2"
                                />
                                Projects
                              </Link>
                            </li> */}
                                {/* <li>
                                <Link
                                  to="/purchase-order"
                                  className={
                                    location.pathname === "/purchase-order"
                                      ? "text-primary"
                                      : ""
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={faArrowRight}
                                    className="me-2"
                                  />
                                  Purchase Order
                                </Link>
                              </li> */}
                                {/* <li>
                                <Link
                                  to="/invoice"
                                  className={
                                    location.pathname === "/invoice"
                                      ? "text-primary"
                                      : ""
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={faArrowRight}
                                    className="me-2"
                                  />
                                  Invoices
                                </Link>
                              </li> */}

                                <li>
                                  <Link
                                    to="/payments"
                                    className={
                                      location.pathname === "/payments"
                                        ? "text-primary"
                                        : ""
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faArrowRight}
                                      className="me-2"
                                    />
                                    Payments
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </li>

                      <li className="mb-2 fw-semibold">
                        <Link
                          to="/products"
                          className={
                            location.pathname === "/products"
                              ? "text-primary"
                              : ""
                          }
                        >
                          <FontAwesomeIcon icon={faBox} className="me-2" />
                          Products
                        </Link>
                      </li>

                      {/* tasks */}

                      <li className="">
                        <Link
                          to="/tasks"
                          className={
                            location.pathname === "/tasks" ? "text-primary" : ""
                          }
                        >
                          <FontAwesomeIcon
                            icon={faListCheck}
                            className="me-2 "
                          />
                          Tasks
                        </Link>
                      </li>
                      <li className="">
                        <Link
                          to="/MyVisits"
                          className={
                            location.pathname === "/MyVisits"
                              ? "text-primary"
                              : ""
                          }
                        >
                          <FontAwesomeIcon icon={faUserTie} className="me-2 " />
                          MyVisits
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/expenses"
                          className={
                            location.pathname === "/expenses"
                              ? "text-primary"
                              : ""
                          }
                        >
                          <FontAwesomeIcon
                            icon={faMoneyBillWave}
                            className="me-2"
                          />
                          Expenses
                        </Link>
                      </li>
                      {/* <li>
                        <Link
                          to="/estimates"
                          className={
                            location.pathname === "/estimates"
                              ? "text-primary"
                              : ""
                          }
                        >
                          <FontAwesomeIcon
                            icon={faFileInvoiceDollar}
                            className="me-2"
                          />
                          Estimates
                        </Link>
                      </li> */}
                      <li>
                        <Link
                          to="/todo"
                          className={
                            location.pathname === "/todo" ? "text-primary" : ""
                          }
                        >
                          <FontAwesomeIcon
                            icon={faListCheck}
                            className="me-2"
                          />
                          Todo
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/reminders"
                          className={
                            location.pathname === "/reminders"
                              ? "text-primary"
                              : ""
                          }
                        >
                          <FontAwesomeIcon icon={faPhone} className="me-2" />
                          Follow Up
                        </Link>
                      </li>

                      {/* sales */}
                      {/* <li>
                    <div className="dropdown">
                      <p
                        className="d-flex"
                        style={{ cursor: "pointer" }}
                        onClick={SalesToggleDropdown}
                      >
                        <a>
                          <span>
                            <FontAwesomeIcon
                              icon={faShoppingCart}
                              className="me-2 text-primary"
                            />
                            Payments
                            <i
                              className={`fa-solid fa-chevron-${
                                salesIsOpen ? "up" : "down"
                              }  fs-6`}
                              style={{ marginLeft: "7.2rem" }}
                            ></i>
                          </span>
                        </a>
                      </p>
                      {salesIsOpen && (
                        <div
                          className="dropdown-content"
                          style={{ marginTop: "-20px" }}
                        >
                          <ul className="ms-3">
                            <li>
                              <Link
                                to="/payments"
                                className={
                                  location.pathname === "/payments"
                                    ? "text-primary"
                                    : ""
                                }
                              >
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  className="me-2"
                                />
                                Payments
                              </Link>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </li> */}

                      {/* reports */}
                      <li>
                        <div className="dropdown">
                          <p
                            className="d-flex"
                            style={{ cursor: "pointer" }}
                            onClick={ReportsToggleDropdown}
                          >
                            <a>
                              <span>
                                <FontAwesomeIcon
                                  icon={faFile}
                                  className="me-2 "
                                />
                                Reports
                                <i
                                  className={`fa-solid fa-chevron-${
                                    reportIsOpen ? "up" : "down"
                                  }  fs-6`}
                                  style={{ marginLeft: "6.1rem" }}
                                ></i>
                              </span>
                            </a>
                          </p>
                          {reportIsOpen && (
                            <div
                              className="dropdown-content"
                              style={{ marginTop: "-20px" }}
                            >
                              <ul className="ms-3">
                                <li>
                                  <Link
                                    to="/leads-report"
                                    className={
                                      location.pathname === "/leads-report"
                                        ? "text-primary"
                                        : ""
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faArrowRight}
                                      className="me-2"
                                    />
                                    Leads
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="/customers-report"
                                    className={
                                      location.pathname === "/customers-report"
                                        ? "text-primary"
                                        : ""
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faArrowRight}
                                      className="me-2"
                                    />
                                    Customers
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="/reminders-report"
                                    className={
                                      location.pathname === "/reminders-report"
                                        ? "text-primary"
                                        : ""
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faArrowRight}
                                      className="me-2"
                                    />
                                    Follow-Ups
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div
                className=" border-top p-3 mt-5"
                onClick={() => {
                  navigate("/settings");
                  setOpenSettings(false); // Optional: close the popover
                }}
              >
                <SettingOutlined style={{ fontSize: 18 }} />
                <span className="ms-2">Settings</span>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile view Sidebar */}
        <div
          className="offcanvas offcanvas-start"
          tabIndex="-1"
          id="offcanvasExample"
          aria-labelledby="offcanvasExampleLabel"
          style={{ width: "60%" }}
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasExampleLabel">
              Pereco CRM
            </h5>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <div id="sidebar-menu" className="sidebar-menu">
              {/* Dashboard */}
              <Link
                to="/dashboard"
                onClick={closeOffcanvas}
                className={`menu-link ${
                  location.pathname === "/dashboard"
                    ? "text-primary"
                    : "text-dark"
                }`}
              >
                <FontAwesomeIcon icon={faHome} />
                <span>Dashboard</span>
              </Link>

              {/* Leads */}
              <Link
                to="/leads"
                onClick={closeOffcanvas}
                className={`menu-link ${
                  location.pathname === "/leads" ? "text-primary" : "text-dark"
                }`}
              >
                <FontAwesomeIcon icon={faUserPlus} />
                <span>Leads</span>
              </Link>

              <Link
                to="/proposal"
                onClick={closeOffcanvas}
                className={`menu-link ${
                  location.pathname === "/proposal"
                    ? "text-primary"
                    : "text-dark"
                }`}
              >
                <FontAwesomeIcon icon={faUserTie} />
                <span>Proposal</span>
              </Link>

              {/* Proposal */}
              <Link
                to="/customers"
                onClick={closeOffcanvas}
                className={`menu-link ${
                  location.pathname === "/customers"
                    ? "text-primary"
                    : "text-dark"
                }`}
              >
                <FontAwesomeIcon icon={faClipboardList} />
                <span>Customers</span>
              </Link>

              {/* Customers */}
              <div
                className="menu-link justify-content-between"
                style={{ cursor: "pointer" }}
                onClick={CustomersToggleDropdown}
              >
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faCreditCard} />
                  <span>Payments</span>
                </div>

                <i
                  className={`fa-solid fa-chevron-${
                    customersIsOpen ? "up" : "down"
                  }`}
                ></i>
              </div>

              {customersIsOpen && (
                <div className="submenu">
                  <Link
                    to="/credits"
                    onClick={closeOffcanvas}
                    className={`submenu-link ${
                      location.pathname === "/credits"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span>Collections</span>
                  </Link>

                  {/* <Link
                    to="/purchase-order"
                    className={`submenu-link ${
                      location.pathname === "/purchase-order"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span>Purchase Order</span>
                  </Link> */}

                  {/* <Link
                    to="/invoice"
                    onClick={closeOffcanvas}
                    className={`submenu-link ${
                      location.pathname === "/invoice"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span>Invoices</span>
                  </Link> */}

                  <Link
                    to="/payments"
                    onClick={closeOffcanvas}
                    className={`submenu-link ${
                      location.pathname === "/payments"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span>Payments</span>
                  </Link>
                </div>
              )}

              <Link
                to="/tasks"
                onClick={closeOffcanvas}
                className={`menu-link ${
                  location.pathname === "/tasks" ? "text-primary" : "text-dark"
                }`}
              >
                <FontAwesomeIcon icon={faListCheck} />
                <span>Tasks</span>
              </Link>

              <Link
                to="/MyVisits"
                onClick={closeOffcanvas}
                className={`menu-link ${
                  location.pathname === "/MyVisits"
                    ? "text-primary"
                    : "text-dark"
                }`}
              >
                <FontAwesomeIcon icon={faListCheck} />
                <span>My Visits</span>
              </Link>

              {/* Products */}
              <Link
                to="/products"
                onClick={closeOffcanvas}
                className={`menu-link ${
                  location.pathname === "/products"
                    ? "text-primary"
                    : "text-dark"
                }`}
              >
                <FontAwesomeIcon icon={faBox} />
                <span>Products</span>
              </Link>

              {/* Expenses */}
              <Link
                to="/expenses"
                onClick={closeOffcanvas}
                className={`menu-link ${
                  location.pathname === "/expenses"
                    ? "text-primary"
                    : "text-dark"
                }`}
              >
                <FontAwesomeIcon icon={faMoneyBillWave} />
                <span>Expenses</span>
              </Link>

              {/* <Link
                to="/estimates"
                onClick={closeOffcanvas}
                className={`menu-link ${
                  location.pathname === "/estimates"
                    ? "text-primary"
                    : "text-dark"
                }`}
              >
                <FontAwesomeIcon icon={faFileInvoiceDollar} className="me-2" />
                Estimates
              </Link> */}

              <Link
                to="/todo"
                onClick={closeOffcanvas}
                className={`menu-link ${
                  location.pathname === "/todo" ? "text-primary" : "text-dark"
                }`}
              >
                <FontAwesomeIcon icon={faListCheck} />
                <span>Todo</span>
              </Link>

              <Link
                to="/reminders"
                className={`menu-link ${
                  location.pathname === "/reminders"
                    ? "text-primary"
                    : "text-dark"
                }`}
              >
                <FontAwesomeIcon icon={faPhone} />
                Follow Up
              </Link>

              {/* Reports */}
              <div
                className="menu-link justify-content-between"
                style={{ cursor: "pointer" }}
                onClick={ReportsToggleDropdown}
              >
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faFile} />
                  <span>Reports</span>
                </div>

                <i
                  className={`fa-solid fa-chevron-${
                    reportIsOpen ? "up" : "down"
                  }`}
                ></i>
              </div>

              {reportIsOpen && (
                <div className="submenu">
                  {/* <Link
                    to="/leads-report"
                    onClick={closeOffcanvas}
                    className={`submenu-link ${
                      location.pathname === "/leads-report"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span>Leads</span>
                  </Link> */}
                  <Link
                    to="/reports/reportId=2"
                    onClick={closeOffcanvas}
                    className={`submenu-link ${
                      location.pathname === "/reports/reportId=2"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span>NewLeads</span>
                  </Link>

                  <Link
                    to="/reports/reportId=1"
                    onClick={closeOffcanvas}
                    className={`submenu-link ${
                      location.pathname === "/reports/reportId=1"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span>Customer Convertion</span>
                  </Link>

                  <Link
                    to="/reports/reportId=3"
                    onClick={closeOffcanvas}
                    className={`submenu-link ${
                      location.pathname === "/reports/reportId=3"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span>Follow-Ups</span>
                  </Link>
                  <Link
                    to="/reports/reportId=4"
                    onClick={closeOffcanvas}
                    className={`submenu-link ${
                      location.pathname === "/reports/reportId=4"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span>Notes</span>
                  </Link>
                  <Link
                    to="/reports/reportId=5"
                    onClick={closeOffcanvas}
                    className={`submenu-link ${
                      location.pathname === "/reports/reportId=5"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span>Invoice</span>
                  </Link>
                  <Link
                    to="/reports/reportId=6"
                    onClick={closeOffcanvas}
                    className={`submenu-link ${
                      location.pathname === "/reports/reportId=6"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span>Estimates</span>
                  </Link>
                  <Link
                    to="/reports/reportId=7"
                    onClick={closeOffcanvas}
                    className={`submenu-link ${
                      location.pathname === "/reports/reportId=7"
                        ? "text-primary"
                        : "text-dark"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span>Proposals</span>
                  </Link>
                </div>
              )}
            </div>
            <div className="sidebar-settings" style={{ width: "100%" }}></div>
          </div>
          <div className="offcanvas-footer">
            <div
              className="menu-link "
              onClick={() => {
                navigate("/settings");
                setOpenSettings(false); // Optional: close the popover
              }}
            >
              <div className="settings-btn">
                <SettingOutlined />
                <span className="ms-2">Settings</span>
              </div>
            </div>
          </div>
        </div>

        {/* Page Content */}
        <div className="page-wrapper">
          <div className="content" style={{ marginBottom: 100 }}>
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default Base;
